import React from "react";
import { ReactComponent as PlusIcon } from "../../../img/plus.svg";
import "./SelectTokensButton.css";
import { SerializedStyles } from "@emotion/react";

export interface SelectTokensButtonProps {
  css?: SerializedStyles;
  visible?: boolean;
  onClick: () => void;
}

export const SelectTokensButton: React.FC<SelectTokensButtonProps> = props => {
  if (!props.visible) {
    return null;
  }
  return (
    <div className="select-tokens-button-container">
      <div
        css={props.css}
        data-testid={"select-tokens-btn"}
        className="text-green d-flex align-items-center add-tokens-btn pointer"
        onClick={() => {
          props.onClick();
        }}
      >
        <PlusIcon width={20} height={20} />
        Add Tokens
      </div>
    </div>
  );
};
